import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useVinCodeService } from '../../services/vinCodeService';
import { useReportService } from '../../services/reportService';
import { latestOrderForVin } from './reportAccess';

/**
 * The user's own latest order for a VIN, looked up only when `active` (the report they opened is not theirs), so the
 * page can offer it instead. { record: null } when there is none, no VIN or no signed-in user. Without a VIN (a pasted
 * /report/<uuid> link of someone else's order), `jobUuid` gives it, only if the user has an order for it (SC-QA-77).
 */
export const useOwnReport = (vin, active, jobUuid = null) => {
    const auth = useAuth();
    const consumerId = auth && auth.currentUser ? auth.currentUser.id : null;
    const { getVinCodesByConsumerId } = useVinCodeService();
    const { getOwnVinForOrder } = useReportService();
    const [state, setState] = useState({ record: null, loading: !!active });

    useEffect(() => {
        let cancelled = false;
        if (!active || !(vin || jobUuid) || !consumerId) {
            setState({ record: null, loading: false });
            return undefined;
        }

        setState({ record: null, loading: true });
        (vin ? Promise.resolve(vin) : getOwnVinForOrder(jobUuid))
            .then(ownVin =>
                ownVin
                    ? getVinCodesByConsumerId(consumerId, ownVin).then(({ data }) => latestOrderForVin(data, ownVin))
                    : null
            )
            .then(record => !cancelled && setState({ record, loading: false }))
            .catch(() => !cancelled && setState({ record: null, loading: false }));

        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active, vin, jobUuid, consumerId]);

    return state;
};
